var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "react-router-dom";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import PipelineService from "../../../Services/Pipeline.service";
import { getPipelineDetailPath, getPipelineEditRoute, } from "../../Pages/Pipeline/PipelineRoutes";
import DateService from "../../../Services/Shared/Date.service";
import { InlineFormFormat } from "../../UI/FormFormat/FormFormat";
import TextField from "../../Form/TextField";
import DateRangeField from "../../Form/DateRangeField";
import SearchField from "../../Form/SearchField";
import { PipelineStatusMultiSearch } from "../../Presentational/Pipeline/PipelineStatusSearch";
import PipelineStatusBadge from "../../Presentational/PipelineStatus/PipelineStatusBadge";
import VirtualizedAppDomainService from "../../../Domain/VirtualizedApp/VirtualizedApp.service";
import PageTitle from "../../UI/PageTitle/PageTitle";
const PAGE_SIZE = 50;
const PipelineListTable = (props) => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({});
    let adminView = true;
    if (props.virtualizedAppName &&
        props.virtualizedAppName !== VirtualizedAppDomainService.ADMIN_APP_NAME) {
        adminView = false;
    }
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No pipelines found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return PipelineService.search(Object.assign(Object.assign({}, sArgs), { virtualizedAppName: props.virtualizedAppName, ignorePermissions: adminView }), {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                sortId: "PIPELINE_NAME",
            },
            {
                title: "Modified",
                sortId: "PIPELINE_MODIFIED_DATE",
            },
            {
                title: "Filter Name",
                sortId: "PIPELINE_POPULATION_NAME",
            },
            { title: "Created By", sortId: "PIPELINE_CREATED_BY" },
            {
                title: "Created On",
                sortId: "PIPELINE_CREATED_DATE",
            },
            {
                title: "Last Opportunity Move",
                sortId: "PIPELINE_LAST_UPDATED_DATE",
            },
            {
                title: "Status",
                sortId: "PIPELINE_STATUS_NAME",
            },
        ],
        rows: ({ data }) => data.map((pipeline) => {
            var _a;
            let link = [];
            if (props.whereToLinkTo === "details") {
                // @ts-expect-error - TS2740 - Type 'ReactElement<any, any>' is missing the following properties from type 'any[]': length, pop, push, concat, and 29 more.
                link = (_jsx(Link, { to: getPipelineDetailPath(pipeline.id, props.virtualizedAppName), children: pipeline.name }, 0));
            }
            else {
                // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'any[]'.
                link = (_jsx(Link, { to: getPipelineEditRoute(pipeline.id), children: pipeline.name }, 0));
            }
            return [
                link,
                DateService.displayWithTime(pipeline.modifiedDate),
                (_a = pipeline.population) === null || _a === void 0 ? void 0 : _a.name,
                pipeline.createdBy.fullName,
                DateService.displayWithTime(pipeline.createdDate),
                DateService.displayWithTime(pipeline.maxOpportunityStageUpdatedDate),
                _jsx(PipelineStatusBadge, { pipelineStatus: pipeline.pipelineStatus }, 1),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "mb-3", children: ["Pipelines ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) ? `(${(_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total})` : ""] }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        var _c, _d, _e, _f, _g, _h, _j;
                        setSearchArgs({
                            modifiedDateFrom: (_c = formState.modifiedDateFrom) === null || _c === void 0 ? void 0 : _c.toDate(),
                            modifiedDateTo: (_d = formState.modifiedDateTo) === null || _d === void 0 ? void 0 : _d.toDate(),
                            createdDateFrom: (_e = formState.createdDateFrom) === null || _e === void 0 ? void 0 : _e.toDate(),
                            createdDateTo: (_f = formState.createdDateTo) === null || _f === void 0 ? void 0 : _f.toDate(),
                            maxOpportunityStageUpdatedDateFrom: (_g = formState.maxOpportunityStageUpdatedDateFrom) === null || _g === void 0 ? void 0 : _g.toDate(),
                            maxOpportunityStageUpdatedDateTo: (_h = formState.maxOpportunityStageUpdatedDateTo) === null || _h === void 0 ? void 0 : _h.toDate(),
                            query: formState.query,
                            pipelineStatusIds: (_j = formState.pipelineStatus) === null || _j === void 0 ? void 0 : _j.map((status) => status.id),
                        });
                    }), children: [_jsx(TextField, { name: "query", label: "Search Name" }), _jsx(DateRangeField, { nameStart: "modifiedDateFrom", nameEnd: "modifiedDateTo", placeHolderStart: "Modified Date From", placeHolderEnd: "Modified Date To", size: "extra-wide" }), _jsx(DateRangeField, { nameStart: "createdDateFrom", nameEnd: "createdDateTo", placeHolderStart: "Created From", placeHolderEnd: "Created To", size: "extra-wide" }), _jsx(DateRangeField, { nameStart: "maxOpportunityStageUpdatedDateFrom", nameEnd: "maxOpportunityStageUpdatedDateTo", placeHolderStart: "Last Move From", placeHolderEnd: "Last Move To", size: "extra-wide" }), _jsx(SearchField, { name: "pipelineStatus", label: "Pipeline Status", as: (provided) => _jsx(PipelineStatusMultiSearch, Object.assign({}, provided)) })] }) }), _jsx("div", { className: "py-2", children: table })] }));
};
export default PipelineListTable;
